import { DocumentProviderType } from 'models/documentProvider';
import { DocumentOutputFolderRule } from 'models/documentOutputLocation';

/** Where the evidence location of a task comes from. Mirrored by numeric value from the API. */
export enum EvidenceLocationSource {
  TenantDefault = 0,
  Template = 1,
}

/**
 * Where the evidence of one task is uploaded: the category, and the task's folder when the rule makes one. Not bound
 * when no category is set for the task; reason then carries the code.
 */
export default class EvidenceLocation {
  bound: boolean;

  reason?: string;

  listId?: number;

  listName?: string;

  listUrl?: string;

  providerType?: DocumentProviderType;

  folderRule?: DocumentOutputFolderRule;

  /** The rendered folder name, two levels joined with '/'. */
  folderName?: string;

  /** Set with ensure, once the folder is found or created by name; the upload starts in it. */
  folderDriveItemId?: string;

  folderUrl?: string;

  source?: EvidenceLocationSource;

  templateName?: string;

  bindingId?: number;

  constructor() {
    this.bound = false;
  }
}
